import MainPageWrapper from '../../global/components/MainPageWrapper'
import TabChooser from './TabChooser'
import AIAssistantContent from '../components/content/AIAssistantContent'
import EvaluationsContent from '../components/content/EvaluationsContent'
import ConversationLogsContent from '../components/content/ConversationLogsContent'
import { TECH_ASSISTANT_KEYS } from '../../global/constants/technician-assistant'

interface ITechnicianAssistantMainProps {
  tabType: TECH_ASSISTANT_KEYS
}

function TechnicianAssistantMain({ tabType }: ITechnicianAssistantMainProps) {
  let content: React.ReactElement | null = null

  switch (tabType) {
    case TECH_ASSISTANT_KEYS.aiAssistant:
      content = <AIAssistantContent />
      break
    case TECH_ASSISTANT_KEYS.evaluations:
      content = <EvaluationsContent />
      break
    case TECH_ASSISTANT_KEYS.conversationLogs:
      content = <ConversationLogsContent />
      break
  }

  return (
    <MainPageWrapper title='Technician Assistant'>
      <TabChooser />
      {content}
    </MainPageWrapper>
  )
}

export default TechnicianAssistantMain
